import { HttpErrorResponse, HttpEvent, HttpHandler, HttpHeaderResponse, HttpInterceptor, HttpProgressEvent, HttpRequest, HttpResponse, HttpSentEvent, HttpUserEvent } from "@angular/common/http";
import { Inject, Injectable, PLATFORM_ID } from "@angular/core";
import { Router } from "@angular/router";

import { Observable } from "rxjs";
import { finalize, share, tap, timeout } from "rxjs/operators";

import { environment } from "@env/environment";
import { CommonService } from "@services/common.service";
import { SharedService } from "@services/shared.service";

@Injectable()
export class AppInterceptor implements HttpInterceptor {
  isTokenValid: boolean = false;
  constructor(
    @Inject(PLATFORM_ID) private platformid,
    private router: Router,
    private commonService: CommonService,
    private sharedService: SharedService
  ) {}
  // tslint:disable-next-line:max-line-length
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<
    | HttpSentEvent
    | HttpHeaderResponse
    | HttpProgressEvent
    | HttpResponse<any>
    | HttpUserEvent<any>
  > {
    let clonedReq: HttpRequest<any>;
    let flightApi: boolean;
      let logEndPoint = 'Common/writeUILogs';
    if (req.url.includes("flight") || req.url.includes("geo")) {
      flightApi = true;
    }
    if (
      req.url.endsWith(".json") ||
      req.url.startsWith("https://") ||
      req.url.startsWith("http://") || req.url.startsWith("api/geo")
    ) {
      clonedReq = req.clone({ url: req.url, headers: null });
    } else {

      let headers = null;
      headers = req.headers.set(
        "Authorization",
        this.commonService.getAuthStr()
      );
    
      if (
        !this.router.url.includes("/flight-details/preview") &&
        (this.router.url.includes("/lp") ||
          this.router.url.includes("payment-success?requestId") ||
          this.router.url.includes("ivity-voucher"))
      ) {
        clonedReq = req.clone({
          url: environment.serverApiUrl + req.url,
          headers: headers,
        });
      } else {
        clonedReq = req.clone({
          url: environment.apiUrl + req.url,
          headers: headers,
        });
      }
    }

    let tempReferenceId;
    this.sharedService.tempReferenceID$.pipe().subscribe((refID) => {
      if (refID != null && refID != "" && refID != undefined) {
        tempReferenceId = refID;
      } else {
      }
    });

    // if (req.url.includes(logEndPoint)) {
    //   return next.handle(req); // skip logging
    // }

    // if (req.url.includes("api.ipify.org") || req.url.includes("ssl.geoplugin.net")) {
    //   // setTimeout(()=>{
    //   this.commonService.logError({
    //     loglevel: "Info",
    //     message:
    //       " Request  from UI -   " +
    //       tempReferenceId +
    //       (clonedReq),
    //   });
    // // },10);
    // }

    const started = performance.now();
    
    return next.handle(clonedReq).pipe(
      timeout(300000),
      tap(
        (event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            // if ((req.url.includes("api.ipify.org") || req.url.includes("ssl.geoplugin.net"))) {
            //   this.commonService.logError({
            //     loglevel: "Info",
            //     message:
            //       " Response  from UI-   " +
            //       tempReferenceId +
            //       (event.body),
            //   });
            // }

            if (!req.url.includes(logEndPoint)) {
            const elapsed = performance.now() - started;

            const log = {
              method: req.method,
              url: req.urlWithParams,
              status: event.status,
              responseTime: elapsed / 1000+"s",
              timestamp: new Date().toISOString()
            };
            // this.commonService.logError(log);
          }
          }
        },
        (err: any) => {
          if (err instanceof HttpErrorResponse) {
            // if (tempReferenceId)
            // if ((req.url.includes("api.ipify.org") || req.url.includes("ssl.geoplugin.net"))) {
            //   setTimeout(()=>{
            //     this.commonService.logError({
            //       loglevel: "Info",
            //       message:
            //         " Error At Interceptor  from UI-   " +
            //         tempReferenceId +
            //         (err),
            //     });
            //   })
             
            // }
           if (!req.url.includes(logEndPoint)) {
            const elapsed = performance.now() - started;
            const log = {
              method: req.method,
              url: req.urlWithParams,
              status: err.status,
              responseTime: elapsed / 1000+"s",
              error: err.message,
              timestamp: new Date().toISOString()
            };
           
            // this.commonService.logError(log);
          }
          }
        }
      ),
      finalize(() => {
        // console.log("== req cancelled ==", clonedReq.url);
      })
    );
  }
}
